var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageLearnerNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.065,
    height: 31.065,
    viewBox: "0 0 31.065 31.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-47.5H31.065v31.065H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.68-20.09a3.27,3.27,0,0,1-3.27,3.27H4.52a3.27,3.27,0,0,1-3.27-3.27V-42.98a3.27,3.27,0,0,1,3.27-3.27H27.41a3.27,3.27,0,0,1,3.27,3.27Z",
    transform: "translate(-0.433 -0.433)",
    fill: "#feffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.241-35.851a1.817,1.817,0,0,1,1.9-1.977,1.817,1.817,0,0,1,1.9,1.977v12.724h4.513A1.723,1.723,0,0,1,27.381-21.3a1.777,1.777,0,0,1-1.825,1.673H19.218a1.879,1.879,0,0,1-1.977-2.079V-35.851Z",
    transform: "translate(-5.965 -3.347)",
    fill: "#4f37af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageLearnerNew);
export default __webpack_public_path__ + "static/media/ManageLearnerNew.c20a8d3edac346b5bc855b57d92caa0a.svg";
export { ForwardRef as ReactComponent };